
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { ToolbarService } from "@/services/toolbar-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { TicketService } from "../../services/ticket-service";
import AppFileImagePreview from "@/components/FileImagePreview.vue";
import VueI18n from "vue-i18n";
import { AuthService } from "@/services/auth-service";
import { AccountantService, IAccountantDossier } from "@/services/accountant-service";
import { ISelectItem } from "winfakt-vue-components";

export default FormLike.extend({
	props: {
		basePath: {
			type: String,
			default: "/support/tickets"
		},
		selectDossier: Boolean,
		dossierId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			subject: "",
			content: "",
			priority: "2",
			departement: "3",
			files: [] as File[],
			validating: false,
			selectedDossierId: 0,
			dossiers: [] as IAccountantDossier[]
		};
	},
	computed: {
		priorities(): any[]{
			return Object.entries(this.$ct("priorities") as any as VueI18n.TranslateResult[]).map(s => {
				return {
					text: s[1],
					value: s[0]
				};
			});
		},
		dossierItems(): ISelectItem<number>[]{
			return this.dossiers.map(d => {
				return {
					value: d.DossierID,
					text: d.CompanyName ? `${d.DossierName} (${d.CompanyName})` : d.DossierName
				};
			}).sort((a, b) => a.text.localeCompare(b.text));
		},
		departements(): any[]{

			let d = Object.entries(this.$ct("departements") as any as VueI18n.TranslateResult[]);

			if(this.isFreeTier || this.serviceExpired){
				this.departement = "2";
				d=d.slice(1, 2);
			}

			return d.map(s => {
				return {
					text: s[1],
					value: s[0]
				};
			});
		},
		serviceExpired():boolean{
			return !this.selectDossier && AuthService.servicePackExpired();
		},
		isFreeTier():boolean{
			return !this.selectDossier && AuthService.wfCompany.Tier === -1;
		}
	},
	methods: {
		removeFile(i: number) {
			this.files.splice(i, 1);
		},
		onFile(file: File) {
			console.trace("On file");
			this.files.push(file);
		},
		async create() {
			this.validating = true;
			this.validate();
			if (!this.isValid) {
				return;
			}
			if (this.selectDossier && !this.selectedDossierId) {
				return;
			}
			let ticket = await TicketService.newTicket(this.subject, this.content, this.files, this.priority, this.departement, this.selectedDossierId);
			this.$router.push(`${this.basePath}/${ticket.id}`);
		},
		async cancel() {
			let confirm = await this.$wf.confirm(this.$ct("cancel-confirm"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.info"), "info");
			if (confirm) {
				this.$router.push(this.basePath);
			}

		}
	},
	async mounted() {
		ToolbarService.title = this.$ct("create-ticket");
		if (!this.selectDossier) {
			return;
		}
		this.dossiers = await AccountantService.getDossiers();
		if (this.dossiers.some(d => d.DossierID == this.dossierId)) {
			this.selectedDossierId = this.dossierId;
			return;
		}
		let firstItem = this.dossierItems[0];
		this.selectedDossierId = firstItem ? firstItem.value : 0;
	},
	destroyed(){
	},
	components: {
		AppFileUpload,
		AppFileImagePreview
	},
	i18nEx: {
		componentPrefix: "components.tickets"
	}
});
